<div class="email-registry-lookup property-input">
    <ul class="search">
        <li class="selected-item" ng-repeat="item in items track by $index">
            {{ item.displayValue }}<i ng-click="remove($event, item)" class="fa fa-times bubble"></i>
        </li>
        <li class="query">
            <input class="search-query"
                   placeholder="{{'email.registry.lookup.placeholder'|translate:language}}"
                   ng-model="query"
                   ng-keydown="keyParser($event)"
                   ng-keyup="search($event)"
                   ng-blur="blur($event)"
                   autocomplete="new-password" />
            <div class="email-registry-selector"
                 ng-show="showSelector">
                <ul class="menu-table">
                    <li class="menu-item" ng-repeat="item in filteredData = (data)"
                        ng-class="$parent.selectorPosition === $index ? 'focus-item' : ''"
                        ng-click="selectorClick($index)">
                        <span>{{item.displayValue}}&nbsp;&lt;{{item.value}}&gt;</span>
                    </li>
                </ul>
            </div>
        </li>
    </ul>
</div>

